import React from 'react';
import { Helmet } from 'react-helmet';
import { Article } from '../../models/article';
import { MenuLink } from '../../models/menu';

interface MetadataProps {
  link: string;
  articles: Article[];
  breadcrumbs: MenuLink[] | undefined;
  homepage: boolean;
}

const Metadata = ({
  link,
  articles = [],
  homepage,
  breadcrumbs,
}: MetadataProps) => (
  <Helmet>
    <script type={'application/ld+json'}>
      {JSON.stringify({
        '@context': 'http://schema.org',
        '@type': 'ItemList',
        url: link,
        numberOfItems: articles.length,
        itemListElement: articles.map(
          (
            {
              created,
              modified,
              link,
              large_image,
              categories = [],
              author: { name },
              title,
            },
            i
          ) => ({
            '@context': 'http://schema.org',
            '@type': 'NewsArticle',
            position: i + 1,
            author: [
              {
                '@type': 'Person',
                name,
              },
            ],
            publisher: {
              '@type': 'Organization',
              name: 'Starts at 60',
              logo: {
                '@type': 'ImageObject',
                url:
                  'https://startsat60.com/app/themes/startsat60v7/favicons/android-chrome-192x192.png',
              },
            },
            mainEntityOfPage: {
              '@type': 'WebPage',
              '@id': link,
            },
            creator: [name],
            headline: title,
            dateCreated: created,
            dateModified: modified,
            datePublished: modified,
            image: {
              '@type': 'ImageObject',
              url: large_image,
            },
            keywords: [...categories.map(({ name }) => name.toLowerCase())],
            thumbnailUrl: large_image,
            url: link,
          })
        ),
      })}
    </script>
    {breadcrumbs && (
      <script type={'application/ld+json'}>
        {JSON.stringify({
          '@context': 'http://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: breadcrumbs.map((breadcrumb, index) => {
            return {
              '@type': 'ListItem',
              position: index + 1,
              item: {
                '@id': breadcrumb.href,
                name: breadcrumb.title,
              },
            };
          }),
        })}
      </script>
    )}
    {homepage && (
      <script type={'application/ld+json'}>
        {JSON.stringify({
          '@context': 'http://schema.org',
          '@type': 'Organization',
          name: 'Starts at 60',
          legalName: 'Starts at 60 Pty Ltd',
          url: 'https://startsat60.com',
          logo:
            'https://startsat60.com/app/themes/startsat60v7/favicons/android-chrome-192x192.png',
          foundingDate: 2014,
          founders: [
            {
              '@type': 'Person',
              name: 'Rebecca Wilson',
            },
          ],
        })}
      </script>
    )}
  </Helmet>
);

export default Metadata;
